export default {
  'invoice.create': 'Create Invoice',
  'invoice.create.notification.success': 'Success',
  'invoice.create.notification.successDescription': 'Invoice Created!',
  'invoice.create.notification.successDescription.edit': 'Edited Invoice!',

  'invoice.column.table.invoiceNumber': 'Number',
  'invoice.column.table.series': 'Series',
  'invoice.column.table.issuanceDate': 'Issuance Date',
  'invoice.column.table.recipient': 'Recipient',
  'invoice.column.table.situation': 'Situation',

  'invoice.column.table.situation.replaced': 'Replaced',
  'invoice.column.table.situation.inTyping': 'In Typing',
  'invoice.column.table.situation.validated': 'Validated',
  'invoice.column.table.situation.processing': 'Processing',
  'invoice.column.table.situation.authorized': 'Authorized',
  'invoice.column.table.situation.canceled': 'Canceled',

  'invoice.domain.company': 'Company',
  'invoice.domain.model': 'Model',
  'invoice.domain.series': 'Series',
  'invoice.domain.number': 'Number',
  'invoice.domain.invoiceKey': 'Invoice Key',
  'invoice.domain.destination': 'Destination',
  'invoice.domain.emissionGoals': 'Purpose of issuance',
  'invoice.domain.emissionGoals.normalNfe': '1 - NF-e Normal',
  'invoice.domain.emissionGoals.additionalNfe': '2 - Complementary NF-e',
  'invoice.domain.emissionGoals.adjustmentNfe': '3 - NF-e Adjustment',
  'invoice.domain.emissionGoals.merchandiseReturnNfe':
    '4 - NF-e Return of Goods',
  'invoice.domain.situation': 'Situation',
  'invoice.domain.situation.initialValue': 'In typing',
  'invoice.domain.emissionDate': 'Issue date',
  'invoice.domain.documentType': 'Document Type',
  'invoice.domain.documentType.entry': '0 - Input',
  'invoice.domain.documentType.exit': '1 - Output',
  'invoice.domain.finalCostumer': 'Final Costumer',
  'invoice.domain.true': 'Yes',
  'invoice.domain.false': 'No',
  'invoice.domain.operationDestination': 'Operation Destination',
  'invoice.domain.operationDestination.internalOperation':
    '1 - Internal Operation',
  'invoice.domain.operationDestination.interstateOperation':
    '2 - Interstate Operation',
  'invoice.domain.operationDestination.foreignOperation':
    '3 - Foreign Operation',
  'invoice.domain.entryExitDate': 'Entry/Exit Date',
  'invoice.domain.emissionType': 'Issue Type',
  'invoice.domain.emissionType.normal': '1 - Normal Issue',
  'invoice.domain.emissionType.contingencyFs':
    '2 - FS-IA contingency, with DANFE printing on security form',
  'invoice.domain.emissionType.contingencyDpec':
    '4 - DPEC Contingency (Previous Declaration of Issuance in Contingency)',
  'invoice.domain.emissionType.contingencyFsda':
    '5 - FS-DA contingency, with DANFE printing on security form',
  'invoice.domain.emissionType.contingencySvcan':
    '6 - SVC-AN Contingency (SEFAZ Virtual AN Contingency)',
  'invoice.domain.emissionType.contingencySvcrs':
    '7 - SVC-RS Contingency (RS Virtual Contingency SEFAZ)',
  'invoice.domain.presenceIndicator': 'Presence Indicator',
  'invoice.domain.presenceIndicator.notApplicable': '0 - Not applicable',
  'invoice.domain.presenceIndicator.faceToFaceOperation':
    '1 - On-site operation',
  'invoice.domain.presenceIndicator.nonFaceToFaceOperationOverTheInternet':
    '2 - Non-face-to-face operation, via the Internet',
  'invoice.domain.presenceIndicator.nonFaceToFaceOperationCallCenter':
    '3 - Non-face-to-face operation, Teleservice',
  'invoice.domain.presenceIndicator.faceToFaceOperationOffSite':
    '5 - In-person operation, off-premises',
  'invoice.domain.presenceIndicator.nonFaceToFaceOperationOthers':
    '9 - Non-face-to-face operation, others',
  'invoice.domain.uf': 'State',
  'invoice.domain.municipalityOccurrence': 'Municipality of Occurrence',
  'invoice.domain.brokerIndicator': 'Intermediary Indicator',
  'invoice.domain.freightIcmsSt':
    'Freight, Expenses are included in the ICMS ST calculation base',
  'invoice.domain.freightIpi':
    'Freight, Expenses are included in the IPI calculation basis',

  'invoice.nfe.recipient.form.recipientType': 'Recipient Type',
  'invoice.nfe.recipient.form.recipientType.client': 'Client',
  'invoice.nfe.recipient.form.recipientType.provider': 'Provider',
  'invoice.nfe.recipient.form.recipientType.insurance': 'Insurance',
  'invoice.nfe.recipient.form.cpf/cnpj': 'CPF/CNPJ',
  'invoice.nfe.recipient.form.provider': 'Provider',
  'invoice.nfe.recipient.form.typeOfTaxpayers': 'Yype Of Taxpayers',
  'invoice.nfe.recipient.form.typeOfTaxpayers.ContributorIcms':
    'Contributor ICMS',
  'invoice.nfe.recipient.form.typeOfTaxpayers.contributorExempt':
    'Contributor Exempt',
  'invoice.nfe.recipient.form.typeOfTaxpayers.nonTaxpayer': 'Non Taxpayer',
  'invoice.nfe.recipient.form.title': 'Transaction Intermediary Information',
  'invoice.nfe.recipient.form.processedByIntermediary':
    'Processed By Intermediary?',
  'invoice.nfe.recipient.form.processedByIntermediary.yes': 'Yes',
  'invoice.nfe.recipient.form.processedByIntermediary.no': 'No',
  'invoice.nfe.recipient.form.intermediaryCnpj': 'Intermediary CNPJ',
  'invoice.nfe.recipient.form.SellerId': 'Seller Id',
  'invoice.nfe.recipient.form.btn.save': 'Save',
  'invoice.nfe.recipient.form.btn.comeBack': 'Come Back',
  'invoice.nfe.recipient.form.btn.referringOs': 'Referring O.S',

  'invoice.nfse.recipient.form.btn.save': 'Save',
  'invoice.nfse.recipient.form.btn.comeBack': 'Come Back',
  'invoice.nfse.recipient.form.btn.transmit': 'Transmit',
  'invoice.nfse.recipient.form.btn.consultStatus': 'Consult Status',
  'invoice.nfse.recipient.form.btn.cancelNote': 'Cancel Note',
  'invoice.nfse.recipient.form.btn.referringOs': 'Referring O.S',

  'invoice.nfse.domain.numberRps': 'RPS Number',
  'invoice.nfse.domain.destination.taxationMunicipality':
    '1 - Taxation in the Municipality',
  'invoice.nfse.domain.destination.taxationOutsideMunicipality':
    '2 - Taxation outside the Municipality',
  'invoice.nfse.domain.destination.immunity': '3 - Immunity',
  'invoice.nfse.domain.destination.immune': '4 - Immune',
  'invoice.nfse.domain.destination.courtDecision':
    '5 - Liability suspended by court decision',
  'invoice.nfse.domain.destination.administrativeProcedure':
    '6 - Liability suspended by administrative procedure',
  'invoice.nfse.domain.municipalTaxCode': 'Municipal Tax Code',
  'invoice.nfse.domain.simpleNational': 'Simple National',
  'invoice.nfse.domain.culturalIncentive': 'Cultural Incentive',
  'invoice.nfse.domain.IssWithheld': 'ISS Withheld',
  'invoice.nfse.domain.deductIss': 'Deduct ISS',
  'invoice.nfse.domain.pisCofinsWithholding': 'PIS/COFINS Withholding',
  'invoice.nfse.domain.additionalInformation': 'Additional Information',

  'invoice.nfse.filters.situation.replaced': 'Replaced',
  'invoice.nfse.filters.situation.inTyping': 'In Typing',
  'invoice.nfse.filters.situation.validated': 'Validated',
  'invoice.nfse.filters.situation.processing': 'Processing',
  'invoice.nfse.filters.situation.authorized': 'Authorized',
  'invoice.nfse.filters.situation.canceled': 'Canceled',
  'invoice.nfse.filters.situation.denied': 'Denied',
  'invoice.nfse.filters.situation.interrupted': 'Interrupted',

  'invoice.disableNumberingRange.helmet.title': 'Disable Numbering Range',
  'invoice.disableNumberingRange.btn.newDisability': 'Disable Numbering',
  'invoice.disableNumberingRange.form.company': 'Company',
  'invoice.disableNumberingRange.form.series': 'Series',
  'invoice.disableNumberingRange.form.model': 'Model',
  'invoice.disableNumberingRange.form.startingNumber': 'Starting Number',
  'invoice.disableNumberingRange.form.finalNumber': 'Final Number',
  'invoice.disableNumberingRange.form.btn.comeBack': 'Come Back',
  'invoice.disableNumberingRange.form.btn.search': 'Search',
  'invoice.disableNumberingRange.form.btn.disable': 'Disable',
  'invoice.disableNumberingRange.form.modalJustification.title':
    'Justification for Disabling',
  'invoice.disableNumberingRange.form.modalJustification.label':
    'Justification of cancellation, inform at least 15 characters',
  'invoice.disableNumberingRange.table.model': 'Model',
  'invoice.disableNumberingRange.table.series': 'Series',
  'invoice.disableNumberingRange.table.dateOfDisability': 'Date Of Disability',
  'invoice.disableNumberingRange.table.initialNumber': 'Initial Number',
  'invoice.disableNumberingRange.table.finalNumber': 'Final Number',

  'invoice.disableNumberingRange.list.table.company': 'Company',
  'invoice.disableNumberingRange.list.table.model': 'Model',
  'invoice.disableNumberingRange.list.table.series': 'Series',
  'invoice.disableNumberingRange.list.table.dateOfDisability':
    'Date of Disability',
  'invoice.disableNumberingRange.list.table.initialNumber': 'Initial Number',
  'invoice.disableNumberingRange.list.table.finalNumber': 'Final Number',
  'invoice.disableNumberingRange.filter.company': 'Company',
  'invoice.disableNumberingRange.filter.model': 'Model',
  'invoice.disableNumberingRange.filter.series': 'Series',
  'invoice.disableNumberingRange.filter.dateOfDisability': 'Date of Disability',
  'invoice.disableNumberingRange.filter.initialNumber': 'Initial Number',
  'invoice.disableNumberingRange.filter.finalNumber': 'Final Number',

  'invoice.sintegra.create.generateFile': 'Generate File',
  'invoice.sintegra.helmet.title': 'Sintegra',
  'invoice.sintegra.form.initialDate': 'Initial Date',
  'invoice.sintegra.form.finalDate': 'Final Date',
  'invoice.sintegra.form.company': 'Company',
  'invoice.sintegra.form.radioGroup.noteType.title': 'Note Type',
  'invoice.sintegra.form.radio.partsAndServices': 'Parts And Services',
  'invoice.sintegra.form.radio.parts': 'Parts',
  'invoice.sintegra.form.radio.services': 'Services',
  'invoice.sintegra.form.radioGroup.filter.title': 'Filter Purchase by Date',
  'invoice.sintegra.form.radio.launch': 'Launch',
  'invoice.sintegra.form.radio.issue': 'Issue',
  'invoice.sintegra.form.checkbox.generateRecord74': 'Generate Record 74',
  'invoice.sintegra.form.checkbox.generateRecord61R': 'Generate Record 61R',
  'invoice.sintegra.form.inventoryData': 'Fetch Inventory Data From',
  'invoice.sintegra.form.inventoryDate': 'InventoryDate',
  'invoice.sintegra.form.PurposeOfPresentation':
    'Purpose of Electronic File Presentation',
  'invoice.sintegra.form.checkbox.removeParts': 'Remove Stereotype from Parts',
  'invoice.sintegra.form.checkbox.removeInputs': 'Remove Stereotype of Inputs',
  'invoice.sintegra.form.select.currentStock': 'Current Stock',
  'invoice.sintegra.form.select.inventory': 'Inventory',
  'invoice.sintegra.form.select.normal': 'Normal',
  'invoice.sintegra.form.select.fullFileRectification':
    'Full File Rectification',

  'invoice.xml.helmet.title': 'Download XML File',
  'invoice.xml.form.company': 'Company',
  'invoice.xml.form.initialDate': 'Initial Date',
  'invoice.xml.form.finalDate': 'Final Date',
  'invoice.xml.form.btn.search': 'Search',

  'invoice.manifestationRecipient.helmet.title': 'Recipients Manifestation',
  'invoice.manifestationRecipient.form.company': 'Empresa',
  'invoice.manifestationRecipient.form.btn.manifestSelectedNotes':
    'Manifest Selected Notes',
  'invoice.manifestationRecipient.form.btn.searchNotesManifest':
    'Search Notes Manifest',
  'invoice.manifestationRecipient.table.situation': 'Situation',
  'invoice.manifestationRecipient.table.manifestation': 'Manifestation',
  'invoice.manifestationRecipient.table.issue': 'Issue',
  'invoice.manifestationRecipient.table.NFeKey': 'NF-e key',
  'invoice.manifestationRecipient.table.NFeAcessKey': 'NF-e access key',
  'invoice.manifestationRecipient.table.lastNSU': 'Last NSU received',
  'invoice.manifestationRecipient.table.provider': 'Provider',
  'invoice.manifestationRecipient.table.value': 'Value',
  'invoice.manifestationRecipient.modal.title': 'Recipients Manifestation',
  'invoice.manifestationRecipient.modal.manifestation': 'Manifestation',
  'invoice.manifestationRecipient.modal.withoutManifestation':
    'Without Manifestation',
  'invoice.manifestationRecipient.modal.confirmed': 'Confirmed',
  'invoice.manifestationRecipient.modal.unknown': 'Unknown',
  'invoice.manifestationRecipient.modal.notPerformed': 'Not Performed',
  'invoice.manifestationRecipient.modal.aware': 'Aware',
  'invoice.manifestationRecipient.modal.date': 'Data',
  'invoice.manifestationRecipient.modal.btn.transmit': 'Transmit',

  'invoice.notifications.create.success.title': 'Success!',
  'invoice.notifications.create.success.description':
    'Invoice created successfully!',

  'invoice.createadditionalData.additionalPhysicalInformation':
    'Additional Information of Interest to the Tax Authorities',
  'invoice.createadditionalData.AdditionalTaxpayerInformation':
    'Additional Information of Interest to the Contributor',
  'invoice.createadditionalData.btn.save': 'Save',
  'invoice.createadditionalData.btn.comeBack': 'Come Back',
  'invoice.createadditionalData.btn.referentialOS': 'referential O.S',
  'invoice.createadditionalData.modal.title': 'Information',
  'invoice.createadditionalData.modal.title.1':
    '1 - @{codeOS} - This tag will be replaced by the O.S.',
  'invoice.createadditionalData.modal.title.2':
    '2 - @{descricaoVeiculo} - This tag will be replaced by the vehicle description.',
  'invoice.createadditionalData.modal.title.3':
    '3 - @{plate} - This tag will be replaced by the vehicles license plate.',
  'invoice.createadditionalData.modal.title.4':
    '4 - @{chassis} - This tag will be replaced by the vehicle chassis.',
  'invoice.createadditionalData.modal.title.5':
    '5 - @{claim} - This tag will be replaced by the claim number.',
  'invoice.createadditionalData.modal.title.6':
    '6 - @{km} - This tag will be replaced by the number of km.',
  'invoice.createadditionalData.modal.title.7':
    '7 - @{ValorTributisAproximado} - This tag will be replaced by the incidence of the percentage of taxes on NFS-e values.',
  'invoice.createadditionalData.modal.title.8':
    '8 - @{totalIR} - This tag will be replaced by the sum of the IRPJ values of the invoice items',
  'invoice.createadditionalData.modal.title.9':
    '9 - @{totalCSLL} - This tag will be replaced by the sum of the CSLL values of the grade items',
  'invoice.createadditionalData.modal.title.10':
    '10 - @{totalPIS} - This tag will be replaced by the sum of the PIS values of the note items',
  'invoice.createadditionalData.modal.title.11':
    '11 - @{totalCofins} - This tag will be replaced by the sum of the Cofins values of the grade items',
  'invoice.createadditionalData.modalOs.nOs': 'N° O.S',
  'invoice.createadditionalData.modalOs.client': 'Client',

  'invoice.remove.notification.success': 'Success',
  'invoice.remove.notification.successDescription': 'Invoice removed.',
  'invoice.remove.confirm.title': 'Remove invoice',
  'invoice.remove.confirm.description':
    'Do you really want to remove a selected invoice?',

  'invoice.create.referenceDocument.table.type': 'Type',
  'invoice.create.referenceDocument.table.model': 'Model',
  'invoice.create.referenceDocument.table.series': 'Series',
  'invoice.create.referenceDocument.table.number': 'Number',
  'invoice.create.referenceDocument.table.issuer': 'Issuer',
  'invoice.create.referenceDocument.table.acessKey': 'Acess Key',
  'invoice.create.referenceDocument.table.issueDate': 'Issue Date',
  'invoice.create.referenceDocument.table.uf': 'UF',

  'invoice.create.referenceDocument.select.selectCashier': 'Select Cashier',
  'invoice.remove.notification.success': 'Success',
  'invoice.status.message.success': 'Invoice removed',
};
